import React from 'react';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';

function AuthNumForm({
  authNum,
  onChangeAuthNum,
  authNumMsg,
  setAuthNumMsg,
  onAuthNumReset,
  handleMouseDown,
  handleAuthNum,
  btnType,
}) {
  const { t } = useTranslation();
  return (
    <React.Fragment>
      <div className="input_box white_box">
        <input
          type="number"
          value={authNum}
          placeholder={t("MY_03_01-GM.msg007")}
          onChange={onChangeAuthNum}
          onBlur={handleAuthNum}
        />
        <div className="r_area">
          {/* <img src="./static/images/icon/ic_check.svg" alt="" /> */}
          {
            authNumMsg && (
              <button
                type="button"
                onClick={() => {
                  setAuthNumMsg("");
                  onAuthNumReset();
                }}
                onMouseDown={handleMouseDown}
              >
                <img src="./static/images/icon/ic_error.svg" alt="" />
              </button>
            )
          }
          {
            (authNum && !authNumMsg) && (
              <button
                type="button"
                onClick={onAuthNumReset}
                onMouseDown={handleMouseDown}
              >
                {/* <img src="./static/images/icon/input_delete_40.svg" alt="" /> */}
                <img src="./static/images/icon/ic_check.svg" alt="" />
              </button>
            )
          }
        </div>
      </div>
      {(authNumMsg && authNum.length > 0) && <div className="info_txt red">{authNumMsg}</div>}
      {
        (btnType === 'resend' && _.isEmpty(authNumMsg)) && (
          <div className="info_txt red">{!authNum && t("MY_03_01-GM.msg008")}</div>
        )
      }
    </React.Fragment>
  );
}

export default AuthNumForm;